import { ConflictType } from '@consigli/types';

export const PID_CONFLICT_TYPES = new Set<string>([
  ConflictType.MISSING_COUNTERPART_OR_ORPHAN,
  ConflictType.DUPLICATE_IDENTIFIER,
  ConflictType.ATTRIBUTE_CONFLICT,
  ConflictType.INCOMPLETE_DATA,
  ConflictType.INCOMPLETE_FUNCTION_OR_ASSEMBLY,
  ConflictType.CONVENTION_NON_CONFORMANCE,
  ConflictType.SPECIFICATION_GAP,
  ConflictType.RATING_EXCEEDANCE,
  ConflictType.REVISION_OR_CURRENCY,
]);

const EXCLUDED_KEYS = new Set(['excelMetadata']);

const toLabel = (key: string): string =>
  key
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (char) => char.toUpperCase())
    .trim();

const toTitleCase = (str: string): string =>
  str
    .replace(/_/g, ' ')
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

const getPidCustomObject = (
  messageTemplate: string,
  conflictType: string,
  messageContext: Record<string, unknown> | undefined,
): Record<string, unknown> | null => {
  if (messageTemplate !== 'FT001' || !PID_CONFLICT_TYPES.has(conflictType)) {
    return null;
  }

  const customMessage = messageContext?.CUSTOM_MESSAGE;
  if (typeof customMessage !== 'object' || customMessage === null) {
    return null;
  }

  return customMessage as Record<string, unknown>;
};

export const getPidCustomMessage = (
  messageTemplate: string,
  conflictType: string,
  messageContext: Record<string, unknown> | undefined,
): string | null => {
  const customMessage = getPidCustomObject(messageTemplate, conflictType, messageContext);
  if (!customMessage) {
    return null;
  }

  const lines = Object.entries(customMessage)
    .filter(
      ([key, value]) =>
        !EXCLUDED_KEYS.has(key) && value !== null && value !== undefined && value !== '',
    )
    .map(([key, value]) => {
      const displayValue =
        typeof value === 'string' && value.includes('_')
          ? toTitleCase(value)
          : typeof value === 'string'
            ? value
            : JSON.stringify(value);
      return `${toLabel(key)}: ${displayValue}`;
    });

  return lines.length > 0 ? lines.join('\n') : null;
};

export const getPidCustomCause = (
  messageTemplate: string,
  conflictType: string,
  messageContext: Record<string, unknown> | undefined,
): string | null => {
  const customMessage = getPidCustomObject(messageTemplate, conflictType, messageContext);
  const cause = customMessage?.cause;
  return typeof cause === 'string' ? cause : null;
};
